module.exports = __webpack_public_path__ + "img/travel3.54d4853b.jpg";